import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from './SteppedCheckoutSkeleton.module.scss';

const SteppedCheckoutSkeleton = () => (
  <div className={styles.container}>
    <Skeleton variant="text" width="100%" sx={{ fontSize: '1rem' }} />

    {Array.from({ length: 2 }).map(() => (
      <div className={styles['stepped-checkout-skeleton-top-section-item']}>
        <div
          className={styles['stepped-checkout-skeleton-top-section-item-title']}
        >
          <Skeleton
            variant="text"
            width="8.5625rem"
            sx={{ fontSize: '1rem' }}
          />
          <Skeleton variant="text" width="3rem" sx={{ fontSize: '1rem' }} />
        </div>

        <div
          className={
            styles['stepped-checkout-skeleton-top-section-item-content']
          }
        >
          <Skeleton
            variant="text"
            width="3.75rem"
            sx={{ fontSize: '0.75rem' }}
          />
          <Skeleton
            variant="text"
            width="7.5rem"
            sx={{ fontSize: '0.75rem' }}
          />
          <Skeleton
            variant="text"
            width="7.5rem"
            sx={{ fontSize: '0.75rem' }}
          />
        </div>
      </div>
    ))}

    <div
      className={styles['stepped-checkout-skeleton-top-section-footer-item']}
    >
      <div
        className={
          styles['stepped-checkout-skeleton-top-section-footer-item-content']
        }
      >
        <Skeleton variant="text" width="9.25rem" sx={{ fontSize: '1rem' }} />
        <Skeleton
          variant="text"
          width="15rem"
          sx={{ fontSize: '0.765625rem' }}
        />
      </div>
    </div>

    <div
      className={
        styles['stepped-checkout-skeleton-payment-method-credit-card-item']
      }
    >
      <div className={styles['stepped-checkout-skeleton-credit-card-title']}>
        <Skeleton variant="rectangular" width="1.5rem" height="1.5rem" />

        <div
          className={
            styles['stepped-checkout-skeleton-credit-card-title-label']
          }
        >
          <Skeleton variant="text" width="9.25rem" sx={{ fontSize: '1rem' }} />
          <Skeleton
            variant="text"
            width="7.5rem"
            sx={{ fontSize: '0.765rem' }}
          />
        </div>
      </div>

      <Skeleton variant="rectangular" height="3.625rem" />
      <div
        className={
          styles['stepped-checkout-skeleton-credit-card-items-2-column']
        }
      >
        <Skeleton variant="rectangular" width="100%" height="3.625rem" />
        <Skeleton variant="rectangular" width="100%" height="3.625rem" />
      </div>
      <Skeleton variant="rectangular" height="3.625rem" />
      <Skeleton variant="rectangular" height="3.625rem" />
    </div>

    {Array.from({ length: 4 }).map((_, index) => (
      <div className={styles['stepped-checkout-skeleton-payment-method-item']}>
        <Skeleton
          // eslint-disable-next-line react/no-array-index-key
          key={`payment-method-item-${index}-icon`}
          variant="rectangular"
          width="1.5rem"
          sx={{ fontSize: '1.5rem' }}
        />
        <Skeleton
          // eslint-disable-next-line react/no-array-index-key
          key={`payment-method-item-${index}-label`}
          variant="rectangular"
          width="15rem"
          sx={{ fontSize: '2rem' }}
        />
      </div>
    ))}
  </div>
);

export default SteppedCheckoutSkeleton;
